export default __webpack_public_path__ + "static/media/IMG_1624.1321bdf6.jpg";